const updateUniforms = (state = {}, action) => {
    const { type = null, datasource, data = {}, params } = action;

    if (type === 'dataEngine_update_response') {
        if (datasource === 'uniforms') {
            return {
                ...data,
                gamePk: params?.gamePk,
                isError: false
            };
        }
    }
    if (type === 'dataEngine_update_error') {
        if (datasource === 'uniforms') {
            return {
                ...state,
                isError: true
            };
        }
    }

    return state;
};

export default updateUniforms;
